enum InterestType {
    Simple = "SIMPLE",
    Compound = "COMPOUND",
}
export default InterestType